var Intesa = Intesa || {};


Intesa.bibTableComponent = function() {
	
	var bibTableComponent = this;
	const bank = $("html").attr("data-bank");
	
	
	this.init = function() {
	
		
		
		if($(".bib-website-table-component").length == 0)
			return;
		
		$(".bib__table__component__arrow").click(function() {
	        if($(this).find('.icon-ic_small_arrow_down').hasClass('inverted')){
	             $(this).find('.icon-ic_small_arrow_down').removeClass('inverted');
	        }else{
	             $(this).find('.icon-ic_small_arrow_down').addClass('inverted');
	        }
		});
		
		$(".bib-website-table-component").each(function(index, element){
	
			if($("div[data-hide-table]", element).attr("data-hide-table") == 'false'){
				
				var fileUrl = $("div[data-table-excel]", element).attr("data-table-excel");
				
				$.ajax({
			          type: 'GET',
			          cache: false,
					  url: fileUrl,
					  context: document.body,
			          xhrFields: {
			              // make sure the response knows we're expecting a binary type in return.
			              // this is important, without it the excel file is marked corrupted.
			              responseType: 'arraybuffer'
			          }
				}).done(function(data, status, xmlHeaderRequest) {
					  var response = data;
					  var table = $(".bib-table-component", element)[0];
					  table.innerHTML = "";
					  
					  var reader = new FileReader();
					  var blob = new Blob([data], {type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
					  reader.readAsArrayBuffer(blob);
					  
					  reader.onload = function (event) {
					    try{
					    	
					      	var buffer = new Uint8Array(reader.result);	
					      
							var workbook = new ExcelJS.Workbook();

							workbook.xlsx.load(buffer).then( function () {
				
								var worksheet = workbook.worksheets[0];

								//console.log(worksheet);

								var lastRow =  worksheet.lastRow.number;

								//console.log(lastRow.number)
								
								//console.log(worksheet.getRows(1 , lastRow));

								var rows = worksheet.getRows(1 , lastRow);

								if(lastRow > 0) {

								var table_output = '<table class="listViewTable table-sortable" id="listViewTable">';

								rows.forEach(function (element , index ){

									table_output += '<tr class="ce1 colorYellow">';
									
									var mergedCells = element.worksheet._merges;

									element.eachCell({includeEmpty: true},function(cell, colNumber) {
										
										var cellValue = null;
										
										if(cell.type == 4){
											var singleBank = $("html").attr("data-bank");
											var cellDate  = new Date(cell.value); 
											if(singleBank == "CIB"){
												cellValue = cellDate.toISOString().split('T')[0].replace(/\-/g,".");
											}
											else{
												var cellValueToChange = cellDate.toISOString().split('T')[0];
                                            	cellValue = cellValueToChange.split("-")[2] + '.' + cellValueToChange.split("-")[1] + '.' +cellValueToChange.split("-")[0]
											}
										}
										else{
											cellValue = cell.value;
										}

										if (index == 0 && cell.isMerged != true) {
											if(cellValue != null){
											table_output += '<th class="name1 hsText">' + cellValue + '</th>';
											}
											else{
												table_output += '<th class="name1 hsText"></th>';
											}
									 	 }else {
									 		 
									 		if(cell.isMerged == true){
									 			if (cell.address in mergedCells){
									 				var rowspan = "";
									 				var colspan = "";
									 				if(mergedCells[cell.address].model.top != mergedCells[cell.address].model.bottom){
									 					var mergedCountCol = mergedCells[cell.address].model.bottom - mergedCells[cell.address].model.top + 1;
									 					rowspan = ' rowspan="' + mergedCountCol + '" ';
									 				}
									 				if(mergedCells[cell.address].model.left != mergedCells[cell.address].model.right){
									 					var mergedCountRow = mergedCells[cell.address].model.right - mergedCells[cell.address].model.left + 1;
									 					colspan = ' colspan="' + mergedCountRow + '" style="text-align:center" ';
									 				}
									 				if (index == 0) {
														if(cellValue != null){
															table_output += '<th class="name1 hsText" ' + rowspan + colspan + '>' + cellValue + '</th>';
														}
														else{
															table_output += '<th class="name1 hsText" ' + rowspan + colspan + '></th>';
														}
												 	}
									 				else{
										 				if (cellValue != undefined && cellValue != null && cellValue.richText == undefined){
															if (cell.style.font != undefined && cell.style.font.bold == true){
																table_output += '<td class="entry1 hsText" ' + rowspan + colspan + '><strong>' + cellValue + '</strong></td>';
															}else{
																table_output += '<td class="entry1 hsText" ' + rowspan + colspan + '>' + cellValue + '</td>';
															}
												 		}
														else if(cellValue != undefined && cellValue != null && cellValue.richText != undefined){
															var cellRichText="";
															for(var i = 0; i<cellValue.richText.length; i++){
																if(cellValue.richText[i].font!=undefined && cellValue.richText[i].font.bold != undefined && cellValue.richText[i].font.bold == true){
																	cellRichText += '<strong>'+ cellValue.richText[i].text + '</strong>';
																	//console.log(cellValue.richText[i]);
																}
																else{
																	//console.log(cellValue.richText[i]);
																	cellRichText += cellValue.richText[i].text;
																}
																
															}
															table_output += '<td class="entry1 hsText" ' + rowspan + colspan + '>' + cellRichText + '</td>';
														}
												 		else{
												 			table_output += '<td class="entry1 hsText" ' + rowspan + colspan + '></td>';
												 		}
									 				}
									 			}
									 		}
									 		else{
										 		if (cellValue != undefined && cellValue != null){
													if (cell.style.font != undefined){
														if(cell.style.font.bold == true){
															table_output += '<td class="entry1 hsText"><strong>' + cellValue + '</strong></td>';
														}else{
															table_output += '<td class="entry1 hsText">' + cellValue + '</td>';
														}	
													}else{
														table_output += '<td class="entry1 hsText">' + cellValue + '</td>';
													}
										 		}
										 		else{
										 			table_output += '<td class="entry1 hsText"></td>';
										 		}
									 		}

										 }

									});

									table_output += '</tr>';
									
								});

								table_output += '</table>';
		
				                table.innerHTML = table_output;

								}


							} );
							
					    } catch (e) {
				    	
					    	console.log(e);
					    }
					    
				    
					  }			  
					  
				});
			}
		});	
		
	}
	
	
	
}

Intesa.bibTableComponent.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

    }

	if( !window.intesa.bib_Table_Component ) {

		window.intesa.bib_Table_Component= new Intesa.bibTableComponent();

	}

	return window.intesa.bib_Table_Component;

};
